import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Buttons, formConfig } from "./ReporteAsesor.form";
import { ReporteAsesorTable } from "./ReporteAsesor.table";
import {
  ReporteAsesorMockUp,
  ResumenAsesorMockUp
} from "./ReporteAsesor.types";
import { mockData, mockResumen } from "./ReporteAsesor.data";
import Layout from "../../layout";
import { Helmet } from "react-helmet";
import { successNotification } from "../../../../utils/notifications";

interface State {
  data: ReporteAsesorMockUp[];
  resumen: ResumenAsesorMockUp | null;
}

export default class ReporteAsesorComponent extends Component<{}, State> {
  state: State = {
    data: [],
    resumen: null
  };

  handleSubmit = (values: any) => {
    this.setState({
      data: mockData,
      resumen: mockResumen
    });

    successNotification("Cargado correctamente");
  };

  handleExport = () => {
    successNotification("Exportado correctamente");
  };

  onChange = (_values: any) => {
    // Placeholder para onChange
  };

  render() {
    const { resumen, data } = this.state;

    return (
      <main>
        <Layout>
          <Helmet title="Mockup" />
          <Container>
            <FormBuilder
              config={formConfig}
              submit={this.handleSubmit}
              onChange={this.onChange}
            ></FormBuilder>

            {resumen && (
              <Row className="mb-4">
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.ventasYReactivaciones}</h3>
                      <p>Ventas y Reactivaciones</p>
                      <small className="text-muted">
                        Sin 3 en incumplimiento
                      </small>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>
                        {resumen.integrantes + resumen.integrantesConCargo}
                      </h3>
                      <p>Integrantes</p>
                      <small className="text-muted">
                        {resumen.integrantesConCargo} con cargo
                      </small>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.descuentos}</h3>
                      <p>Descontadas del alcance</p>
                      <small>
                        {resumen.verMembresias && (
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              alert(
                                "Se mostrarán Membresías sin expediente completo"
                              );
                            }}
                          >
                            Ver membresías
                          </a>
                        )}
                      </small>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.alcance}%</h3>
                      <p>Alcance</p>
                      <small className="text-muted">
                        Meta consolidada: 27{" "}
                      </small>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}

            {data.length > 0 && (
              <ReporteAsesorTable data={data} onExport={this.handleExport} />
            )}
          </Container>
        </Layout>
      </main>
    );
  }
}
